<template>
  <q-page class="row justify-center">
    <q-inner-loading :showing="true">
      <q-spinner-hourglass color="primary" size="2em" />
    </q-inner-loading>
  </q-page>
</template>

<script>
export default {
  name: 'ChunkLoading'
}
</script>
